import {withExplicitProps} from 'polyphony/hoc';
import {parseHTML} from 'polyphony/html';

const RawHTML = withExplicitProps(({children}) => parseHTML(children), ['children']);
RawHTML.displayName = 'RawHTML';

export default RawHTML;

